import React from 'react'

const index = () => {
  return (
    <div>Structure</div>
  )
}

export default index